import React from 'react';
import classNames from 'classnames';
import './app-store.css';

const AppStore = (props) => {
	const {size} = props;
	const AppStoreClass = classNames({
		'app-store': true,
		[`app-store--${size}`]: !!size
	});
	return (
		<a href="https://www.apple.com/itunes/" target="_blank">
			<svg className={AppStoreClass} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 119.6 40">
				<g>
					<path className='app-store__border'
						d="M110.1,0H7.5a13.55,13.55,0,0,0-2,.2A7,7,0,0,0,3.6.8,6.1,6.1,0,0,0,2,2,6.1,6.1,0,0,0,.8,3.6,7,7,0,0,0,.2,5.5a15,15,0,0,0-.2,2V32.4a13.55,13.55,0,0,0,.2,2,6,6,0,0,0,.6,1.9A5.23,5.23,0,0,0,2,38a6.1,6.1,0,0,0,1.6,1.2,6,6,0,0,0,1.9.6,13.55,13.55,0,0,0,2,.2H112.1a13.55,13.55,0,0,0,2-.2,6,6,0,0,0,1.9-.6,7.07,7.07,0,0,0,2.8-2.8,6,6,0,0,0,.6-1.9,13.55,13.55,0,0,0,.2-2V7.5a13.55,13.55,0,0,0-.2-2,6,6,0,0,0-.6-1.9A6.32,6.32,0,0,0,116,.8a6,6,0,0,0-1.9-.6,13.55,13.55,0,0,0-2-.2h-2Z"
						transform="translate(0 0)"/>
					<path
						d="M8.4,39.1H7.5a12.25,12.25,0,0,1-1.9-.2,10.93,10.93,0,0,1-1.7-.5,7.1,7.1,0,0,1-1.4-1,4.51,4.51,0,0,1-1-1.4A4.8,4.8,0,0,1,1,34.3a11.08,11.08,0,0,1-.2-1.9V7.5A12.25,12.25,0,0,1,1,5.6,5.23,5.23,0,0,1,1.6,4a7.1,7.1,0,0,1,1-1.4A7.1,7.1,0,0,1,4,1.6a4.8,4.8,0,0,1,1.7-.5A11.08,11.08,0,0,1,7.6.9H112.2a13.66,13.66,0,0,1,1.9.2,10.93,10.93,0,0,1,1.7.5A5.56,5.56,0,0,1,118.2,4a4.94,4.94,0,0,1,.5,1.6,12.25,12.25,0,0,1,.2,1.9V32.4a13.66,13.66,0,0,1-.2,1.9,10.93,10.93,0,0,1-.5,1.7,7.1,7.1,0,0,1-1,1.4,4.51,4.51,0,0,1-1.4,1,3.37,3.37,0,0,1-1.7.5,11.08,11.08,0,0,1-1.9.2H8.4Z"
						transform="translate(0 0)" fill="#fff"/>
				</g>
				<g className='app-store__content'>
					<g>
						<path
							d="M25,19.9a4.84,4.84,0,0,1,2.5-4.3,5.08,5.08,0,0,0-4.2-2.2c-1.7-.2-3.4,1-4.3,1s-2.3-1-3.8-1a5.78,5.78,0,0,0-4.7,2.8c-2,3.5-.5,8.6,1.4,11.4,1,1.4,2.1,2.9,3.6,2.9s2-.9,3.7-.9,2.2.9,3.7.9,2.5-1.4,3.5-2.8A13.69,13.69,0,0,0,28,24.5,5.05,5.05,0,0,1,25,19.9Z"
							transform="translate(0 0)"/>
						<path
							d="M22.2,11.5a5.24,5.24,0,0,0,1.2-3.6A4.69,4.69,0,0,0,20,9.6a5,5,0,0,0-1.2,3.5A4.58,4.58,0,0,0,22.2,11.5Z"
							transform="translate(0 0)"/>
					</g>
					<g>
						<path d="M42.3,27.1H37.6l-1.1,3.4h-2L39,18.1h2l4.5,12.4h-2Zm-4.2-1.5h3.8L40,20.1h-.1Z"
							  transform="translate(0 0)"/>
						<path
							d="M55.2,26c0,2.8-1.5,4.6-3.8,4.6A2.91,2.91,0,0,1,48.6,29h0v4.5H46.7v-12h1.8V23h0a3.36,3.36,0,0,1,2.9-1.6C53.6,21.3,55.2,23.2,55.2,26Zm-2,0c0-1.8-.9-3-2.4-3s-2.4,1.2-2.4,3,1,3,2.4,3,2.4-1.2,2.4-3Z"
							transform="translate(0 0)"/>
						<path
							d="M65.1,26c0,2.8-1.5,4.6-3.8,4.6A2.91,2.91,0,0,1,58.5,29h0v4.5H56.6v-12h1.8V23h0a3.36,3.36,0,0,1,2.9-1.6C63.6,21.3,65.1,23.2,65.1,26Zm-1.9,0c0-1.8-.9-3-2.4-3s-2.4,1.2-2.4,3,1,3,2.4,3S63.2,27.8,63.2,26Z"
							transform="translate(0 0)"/>
						<path
							d="M71.7,27c.1,1.2,1.3,2,3,2s2.7-.8,2.7-1.9-.7-1.5-2.3-1.9l-1.6-.4c-2.3-.6-3.3-1.6-3.3-3.3,0-2.1,1.9-3.6,4.5-3.6s4.4,1.5,4.5,3.6H77.3a2.32,2.32,0,0,0-2.6-2c-1.5,0-2.5.8-2.5,1.9,0,.9.7,1.4,2.3,1.8l1.4.3c2.5.6,3.6,1.6,3.6,3.4,0,2.3-1.8,3.8-4.8,3.8-2.8,0-4.6-1.4-4.7-3.7Z"
							transform="translate(0 0)"/>
						<path
							d="M83.3,19.3v2.1H85v1.5H83.3v5c0,.8.3,1.1,1.1,1.1H85v1.5a3.4,3.4,0,0,1-1,.1c-1.8,0-2.5-.7-2.5-2.4V23H80.2V21.5h1.3V19.4h1.8Z"
							transform="translate(0 0)"/>
						<path
							d="M86.1,26c0-2.8,1.7-4.6,4.3-4.6s4.3,1.8,4.3,4.6-1.7,4.6-4.3,4.6S86.1,28.8,86.1,26Zm6.7,0c0-2-.9-3.1-2.4-3.1S88,24,88,26s.9,3.1,2.4,3.1,2.4-1.2,2.4-3.1Z"
							transform="translate(0 0)"/>
						<path
							d="M96.2,21.4H98V23h0a2.07,2.07,0,0,1,2.2-1.6,1.27,1.27,0,0,1,.6.1v1.7a2.49,2.49,0,0,0-.8-.1,1.88,1.88,0,0,0-1.9,1.8v5.7H96.2Z"
							transform="translate(0 0)"/>
						<path
							d="M109.4,27.8c-.2,1.6-1.9,2.8-3.9,2.8-2.6,0-4.3-1.8-4.3-4.6s1.6-4.7,4.2-4.7,4.1,1.7,4.1,4.5v.6h-6.4v.1a2.43,2.43,0,0,0,2.1,2.6h.3a2,2,0,0,0,2.1-1.3Zm-6.3-2.7h4.5a2.22,2.22,0,0,0-2.1-2.3h-.2a2.24,2.24,0,0,0-2.2,2.3Z"
							transform="translate(0 0)"/>
					</g>
					<g>
						<path
							d="M37.8,8.7a2.6,2.6,0,0,1,2.8,2.4v.5c0,1.9-1,3-2.8,3H35.6v-6h2.2Zm-1.2,5.2h1.1a1.89,1.89,0,0,0,2-1.8v-.4a1.9,1.9,0,0,0-1.6-2.1H36.6Z"
							transform="translate(0 0)"/>
						<path
							d="M41.7,12.4a2.11,2.11,0,0,1,4.2-.4v.4a2.11,2.11,0,0,1-4.2.4Zm3.3,0q0-1.5-1.2-1.5c-.8,0-1.2.6-1.2,1.5S43,14,43.8,14s1.2-.6,1.2-1.6Z"
							transform="translate(0 0)"/>
						<path d="M51.6,14.7h-.9l-.9-3.3h-.1l-.9,3.3h-.9l-1.2-4.5h.9l.8,3.4h.1l.9-3.4h.9l.9,3.4h.1l.8-3.4H53Z"
							  transform="translate(0 0)"/>
						<path
							d="M53.9,10.2h.9v.7h.1a1.44,1.44,0,0,1,1.3-.8,1.47,1.47,0,0,1,1.6,1.4v3.2h-.9V12c0-.7-.3-1.1-1-1.1a1,1,0,0,0-1.1,1v2.8h-.9Z"
							transform="translate(0 0)"/>
						<path d="M59.1,8.4H60v6.3h-.9Z" transform="translate(0 0)"/>
						<path
							d="M61.2,12.4a2.11,2.11,0,0,1,4.2-.4v.4a2.11,2.11,0,0,1-4.2.4Zm3.4,0q0-1.5-1.2-1.5c-.8,0-1.2.6-1.2,1.5s.4,1.6,1.2,1.6S64.6,13.4,64.6,12.4Z"
							transform="translate(0 0)"/>
						<path
							d="M66.4,13.4c0-.8.6-1.3,1.7-1.3l1.2-.1v-.4c0-.5-.3-.7-.9-.7s-.8.2-.9.5h-.9a1.61,1.61,0,0,1,1.8-1.3c1.1,0,1.8.6,1.8,1.5v3.1h-.9v-.6h-.1a1.51,1.51,0,0,1-1.4.7,1.42,1.42,0,0,1-1.5-1.2C66.4,13.5,66.4,13.5,66.4,13.4Zm2.9-.4v-.4l-1.1.1c-.6,0-.9.3-.9.6s.4.6.8.6c.6.2,1.1-.2,1.2-.9Z"
							transform="translate(0 0)"/>
						<path
							d="M71.3,12.4c0-1.4.7-2.3,1.9-2.3a1.6,1.6,0,0,1,1.4.8h.1V8.4h.9v6.3h-.9V14h-.1a1.6,1.6,0,0,1-1.4.8C72.1,14.8,71.3,13.9,71.3,12.4Zm1,0c0,1,.5,1.5,1.2,1.5s1.2-.6,1.2-1.5-.5-1.5-1.2-1.5-1.2.6-1.2,1.5Z"
							transform="translate(0 0)"/>
						<path
							d="M79.2,12.4a2.11,2.11,0,0,1,4.2-.4v.4a2.11,2.11,0,0,1-4.2.4Zm3.4,0q0-1.5-1.2-1.5c-.8,0-1.2.6-1.2,1.5s.4,1.6,1.2,1.6S82.6,13.4,82.6,12.4Z"
							transform="translate(0 0)"/>
						<path
							d="M84.7,10.2h.9v.7h.1a1.44,1.44,0,0,1,1.3-.8,1.47,1.47,0,0,1,1.6,1.4v3.2h-.9V12c0-.7-.3-1.1-1-1.1a1,1,0,0,0-1.1,1v2.8h-.9Z"
							transform="translate(0 0)"/>
						<path d="M93.5,9.1v1.1h1V11h-1v2.3c0,.5.2.7.6.7h.3v.7h-.5c-1,0-1.4-.3-1.4-1.2V11h-.7v-.7h.7V9.1Z"
							  transform="translate(0 0)"/>
						<path
							d="M95.7,8.4h.9v2.5h.1a1.34,1.34,0,0,1,1.4-.8,1.62,1.62,0,0,1,1.6,1.4v3.2h-.9V12c0-.7-.3-1.1-1-1.1a1,1,0,0,0-1.1,1v2.8h-.9Z"
							transform="translate(0 0)"/>
						<path
							d="M104.8,13.5a1.88,1.88,0,0,1-2,1.3,2.09,2.09,0,0,1-2.1-2v-.3a2,2,0,0,1,1.8-2.3h.3c1.3,0,2,.9,2,2.3v.3h-3.2a1.16,1.16,0,0,0,1.1,1.3h.1a1.17,1.17,0,0,0,1.1-.5ZM101.6,12h2.3a1.19,1.19,0,0,0-1-1.2h-.1a1.38,1.38,0,0,0-1.2,1.2Z"
							transform="translate(0 0)"/>
					</g>
				</g>
			</svg>
		</a>
	);
};

export default AppStore;



// WEBPACK FOOTER //
// ./src/components/AppStore/AppStore.js